import React from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import isEmail from 'validator/es/lib/isEmail';
import isMobilePhone from 'validator/es/lib/isMobilePhone';

const FormView = ({ setXTransition, setYTransition, isId, country }) => {
  const {
    register,
    handleSubmit,
    errors,
    clearErrors,
    watch,
    setError,
    formState,
  } = useForm({
    mode: 'onBlur',
    shouldFocusError: false,
  });

  const countryCode = {
    my: 'ms-MY',
    sg: 'en-SG',
    id: 'id-ID',
  };

  const onSubmit = async (data, e) => {
    const url =
      'https://script.google.com/macros/s/AKfycbx8FlkiUaWzfoCJoWnXeVc2ck7WooZgEo0CnZ_yZVMvH01M3dg/exec';

    await axios({
      method: 'get',
      url,
      params: {
        timestamp: new Date().toLocaleString(),
        email_address: data.email,
        phone_number: data.phone,
        country,
      },
    })
      .then((response) => {
        setYTransition(`translateY(-${window.innerHeight}px)`); // vh on mobile issue
        e.target.reset();
      })
      .catch((err) =>
        setError('form', {
          type: 'manual',
          message: 'There was an error submitting the form. Please try again.',
        })
      );
  };

  return (
    <main className="form h-100vh flex flex-col">
      <div className="container flex flex-col h-100">
        <button
          className="back"
          onClick={() => setXTransition('translateX(0)')}
        />
        <section className="flex flex-col h-100">
          <header>
            <h1 className="title">{isId ? 'Akses Awal' : 'Early Access'}</h1>
            <p>
              {isId
                ? 'Berikan detail login Fave Anda untuk mendapatkan akses awal kami.'
                : 'Provide us your current Fave login details to be on the early access list.'}
            </p>
          </header>
          <form
            className="flex flex-col h-100"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="center-container">
              <h2>
                {isId
                  ? 'Metode login Fave apa yang anda gunakan?'
                  : 'What login method are you using on Fave?'}
              </h2>
              {errors.form && (
                <span className="form-error">{errors.form.message}</span>
              )}
              <label>
                {errors.email && (
                  <span className="error">
                    {isId ? 'Format email yang salah' : 'Invalid email format'}
                  </span>
                )}
                <input
                  onFocus={() => clearErrors('email')}
                  ref={register({
                    required: true,
                    validate: (input) => isEmail(input),
                  })}
                  type="email"
                  name="email"
                  id="email"
                  placeholder={isId ? 'Alamat email' : 'Email address'}
                />
                <span>{isId ? 'Alamat email' : 'Email address'}</span>
              </label>
              <label>
                {errors.phone && (
                  <span className="error">
                    {isId
                      ? 'Format telepon yang salah'
                      : 'Invalid phone format'}
                  </span>
                )}
                <input
                  ref={register({
                    validate: (input) =>
                      input.length > 0
                        ? isMobilePhone(input, countryCode[country])
                        : true,
                  })}
                  onFocus={() => clearErrors('phone')}
                  type="tel"
                  name="phone"
                  id="phone"
                  placeholder={isId ? 'Nomor telepon' : 'Phone number'}
                />
                <span>{isId ? 'Nomor telepon' : 'Phone number'}</span>
              </label>
            </div>
            <button
              disabled={!watch('email') || formState.isSubmitting}
              className="button full mt-auto thick"
            >
              {isId ? 'Dapatkan Akses Awal' : 'Get Early Access'}
            </button>
          </form>
        </section>
      </div>
    </main>
  );
};

export default FormView;
